"use client";
import React, { useEffect, useState } from 'react';
import Helper from '../../util/helper';
import { DatePicker, Modal, Select } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import formatMsg from '../../util/formatMsg';
import { timeutil } from "sharedresources";
import { ModalWrapper } from '../wrapperComponents/page';

interface FilterObject {
  dateRange: any
  setDateRange: any,
  restrictEndToDayEnd?: boolean;
  paramPrefix?: string;
  defaultDateRangeType?: string;
  disabled?: boolean
}

const FilterDateSelector: React.FC<FilterObject> = ({ dateRange, setDateRange, restrictEndToDayEnd, paramPrefix = '', defaultDateRangeType, disabled = false }) => {
  const dateRangeKey = `${paramPrefix}dateRange`;
  const startDateKey = `${paramPrefix}startDate`;
  const endDateKey = `${paramPrefix}endDate`;
  const [tempDateRange, settempDateRange] = useState(null);
  const [dateRangeType, setDateRangeType] = useState(Helper.getUrlParam(dateRangeKey) || defaultDateRangeType || "thisMonth");
  const [showCustomDateRangeModal, setshowCustomDateRangeModal] = useState(false);


  useEffect(() => {
    if (dateRangeType != "Custom") Helper.setUrlParam(dateRangeKey, dateRangeType);
    switch (dateRangeType) {
      case "today":
        setDateRange([timeutil.getInstance().startOf("day"), timeutil.getInstance().endOf("day")]);
        break;
      case "yesterday":
        setDateRange([timeutil.getInstance().subtract(1, "day").startOf("day"), timeutil.getInstance().subtract(1, "day").endOf("day")]);
        break;
      case "thisWeek":
        setDateRange([timeutil.getInstance().startOf("week"), timeutil.getInstance().endOf("week")]);
        break;
      case "thisMonth":
        setDateRange([timeutil.getInstance().startOf("month"), restrictEndToDayEnd ? timeutil.getInstance().endOf("day") : timeutil.getInstance().endOf("month")]);
        break;
      case "lastMonth":
        setDateRange([timeutil.getInstance().subtract(1, "month").startOf("month"), timeutil.getInstance().subtract(1, "month").endOf("month")]);
        break;
      case "thisYear":
        setDateRange([timeutil.getInstance().startOf("year"), restrictEndToDayEnd ? timeutil.getInstance().endOf("day") : timeutil.getInstance().endOf("year")]);
        break;
      case "lifetime":
        setDateRange([timeutil.getInstance(1), restrictEndToDayEnd ? timeutil.getInstance().endOf("day") : timeutil.getInstance(9999999999999)]);
        break;
      case "customDateParam":
        if (Helper.getUrlParam(startDateKey) && Helper.getUrlParam(endDateKey)) {
          setDateRangeType("Custom")
          setDateRange([timeutil.getInstance(Number(Helper.getUrlParam(startDateKey))), timeutil.getInstance(Number(Helper.getUrlParam(endDateKey)))])
          settempDateRange([timeutil.getInstance(Number(Helper.getUrlParam(startDateKey))), timeutil.getInstance(Number(Helper.getUrlParam(endDateKey)))])
        } else {
          setDateRangeType("thisMonth");
        }
        break;
    }
  }, [dateRangeType])

  useEffect(() => {
    if (dateRange?.length === 2) {
      Helper.setUrlParam(startDateKey, `${timeutil.getEpoch(dateRange[0])}`)
      Helper.setUrlParam(endDateKey, `${timeutil.getEpoch(dateRange[1])}`)
    }
  }, [dateRange])

  return (
    <div>
      <Select
        placeholder={formatMsg("search")}
        suffixIcon={<CalendarOutlined />}
        value={dateRangeType}
        onChange={(e) => {
          if (e === "custom") {
            setshowCustomDateRangeModal(true)
            setDateRangeType("Custom")
          }
          else setDateRangeType(e)
        }}
        style={{ width: "100%" }}
        disabled={disabled}
      >
        {Helper.getDateRanges().map(dateRange =>
          <Select.Option
            key={dateRange}
            value={dateRange}
          >
            {dateRange === "Custom" ? formatMsg("customDateRange") : formatMsg(dateRange)}
          </Select.Option>
        )}
      </Select>
      <ModalWrapper
        title={"Select date range"}
        open={showCustomDateRangeModal}
        onOk={() => {
          Helper.setUrlParam(dateRangeKey, "customDateParam");
          setDateRange(tempDateRange)
          setshowCustomDateRangeModal(false)
        }}
        onCancel={() => {
          settempDateRange(null)
          setshowCustomDateRangeModal(false)
        }}
        okText="Save"
        maskClosable={false}
      >
        <DatePicker.RangePicker
          format={"DD MMM'YY"}
          value={tempDateRange}
          onChange={settempDateRange}
          allowClear={false}
          style={{ width: "100%", marginTop: 24, marginBottom: 24 }}
          disabledDate={(current) => {
            if (!restrictEndToDayEnd) return false;
            return current && current > timeutil.getInstance().endOf("day");
          }}
        />
      </ModalWrapper>
    </div>
  )
}

export default FilterDateSelector